import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('../views/ForgotPasswordView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('../views/ResetPasswordView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/DashboardView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/qr-codes',
    name: 'qr-codes',
    component: () => import('../views/QrCodesView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/analytics',
    name: 'analytics',
    component: () => import('../views/AnalyticsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('../views/UsersView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  }
]

const baseUrl = import.meta.env.BASE_URL || '/'

const router = createRouter({
  history: createWebHistory(baseUrl),
  routes
})

// Navigation guard - Vue Router 5 return-based pattern (no next() callback)
router.beforeEach((to) => {
  const isAuthenticated = !!localStorage.getItem('accessToken')
  const userRole = localStorage.getItem('userRole')

  // Check authentication
  if (to.meta.requiresAuth && !isAuthenticated) {
    return '/login'
  }

  // Check admin role for admin-only routes
  if (to.meta.requiresAdmin && userRole !== 'admin') {
    return '/dashboard'
  }

  // Redirect authenticated users away from login
  if (to.path === '/login' && isAuthenticated) {
    return '/dashboard'
  }
})

export default router
